/* eslint-disable react/no-unescaped-entities */
import { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import Footer from '../../components/Footer';
import HeaderOLD from '../../components/OLD_Header';
import ImageTape from '../../components/ImageTape';

const Style = styled.div`
  .h-header {
    padding: 16px;
  }

  .es-container {
    display: flex;

    @media screen and (min-width: 768px) {
      padding: 24px;
      background-color: #f7f7f7;

      > div {
        flex: 1 1 0;
      }
    }

    .es-image {
      display: none;
      background-image: url('https://firebasestorage.googleapis.com/v0/b/dineouticeland.appspot.com/o/static%2Fcuisines%2Feuropean.jpg?alt=media&token=5a0c0a2e-1560-4dd4-8249-26284d32f933');
      background-size: cover;
      background-position: center center;

      @media screen and (min-width: 768px) {
        display: block;
      }
    }

    .es-info {
      text-align: center;
      background-color: #fff;

      @media screen and (min-width: 768px) {
        padding: 32px;
      }

      sub {
        font-size: 14px;
        margin: 0px;
        padding: 0px;
        color: #999;

        b {
          color: #FF6E3D;
        }
      }

      .es-info-form {
        margin-top: 32px;

        input[type='submit'] {
          height: 69px;
          margin-top: 16px;
          background-color: #fabb66;
          color: #fff;
          border-radius: 3px;

          line-height: normal;
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          letter-spacing: 0.333px;
          user-select: none;
        }
      }

      .es-terms {
        font-size: 13px;
      }
    }
  }
`;

const EmailSignup: FC<RouteComponentProps> = ({ history }) => {
  return (
    <>
      <Style>
        <HeaderOLD inverted />
        <div className="container">
          <div className="es-container">
            <div className="es-image" />

            <div className="es-info">
              <h2>Sign up for the Dineout newsletter</h2>
              <sub>
                <b>Gift cards giveway</b> every month!
                <br />
                Offers, updates and restaurant ideas.
                <br />
                We won't spam you, that's a promise.
              </sub>

              <div className="es-info-form">
                <div id="mc_embed_signup">
                  <form
                    action="https://dineout.us4.list-manage.com/subscribe/post?u=377eee3abca4e30377659034e&amp;id=2927eea97c"
                    method="post"
                    id="mc-embedded-subscribe-form"
                    name="mc-embedded-subscribe-form"
                    className="validate"
                    target="_blank"
                    noValidate
                  >
                    <div id="mc_embed_signup_scroll">
                      <div className="mc-field-group">
                        <input
                          type="email"
                          defaultValue=""
                          name="EMAIL"
                          className="required email"
                          id="mce-EMAIL"
                          placeholder="Email address"
                        />
                      </div>
                      <div id="mce-responses" className="clear">
                        <div
                          className="response"
                          id="mce-error-response"
                          style={{ display: 'none' }}
                        ></div>
                        <div
                          className="response"
                          id="mce-success-response"
                          style={{ display: 'none' }}
                        ></div>
                      </div>
                      <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                        <input
                          type="text"
                          name="b_377eee3abca4e30377659034e_2927eea97c"
                          tabIndex={-1}
                          defaultValue=""
                        />
                      </div>
                      <div className="clear">
                        <input
                          type="submit"
                          defaultValue="Subscribe"
                          name="subscribe"
                          id="mc-embedded-subscribe"
                          className="button"
                          onClick={(e) => {
                            e.currentTarget!.form!.submit();
                            history.push('/signup/thankyou');
                          }}
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <p className="es-terms">
                By signing up, you agree to the Dineout{' '}
                <a tabIndex={-1} href="/terms" target="_blank">
                  Terms of Use
                </a>{' '}
                and acknowledge our{' '}
                <a tabIndex={-1} href="/terms" target="_blank">
                  Privacy Policy
                </a>
                .
              </p>
            </div>
          </div>
        </div>

        <ImageTape />
      </Style>
      <Footer />
    </>
  );
};

export default EmailSignup;
